import { Tabs, TabsProps } from "antd";
import { List } from "@refinedev/antd";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { InvestorManagementShow } from "./Investor-Management-Show/Investor-Management-Show";
import { InvestorManagementDocsList } from "./InvestorManagementDocsList";

export function InvestorManagementPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const tabKey = searchParams.get("tab") || "content";

  const onChange = (key: string) => {
    navigate(
      { search: createSearchParams({ tab: key }).toString() },
      { replace: true }
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "content",
      label: "Контент",
      children: <InvestorManagementShow />,
    },
    {
      key: "docs",
      label: "Документы",
      children: <InvestorManagementDocsList />,
    },
  ];

  return (
    <List
      title="Руководство инвестора"
      resource={"investor-management"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
    >
      <Tabs items={items} onChange={onChange} activeKey={tabKey} />
    </List>
  );
}
